import db from "../driverappdb";

export const SettingsRepository = {
    getSettingsByGroup: async (group) => {
        return await db.settings.where({ group: group }).toArray();
    },
    updateSetting: async (id, value) => {
        return await db.settings.update(id, { value: value });
    }
};